import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature } from 'src/WebApiController';

import { TagsFormBodyProps } from './TagsFormBody.types';
import { TagsFormBodyV2 } from './TagsFormBodyV2';
import { TagsFormBodyV3 } from './TagsFormBodyV3';

export const TagsFormBody = (props: TagsFormBodyProps) => {
  const hasTagsUiV3Feature = useUserHasFeature(Feature.TagsUiV3);

  return hasTagsUiV3Feature ? (
    <TagsFormBodyV3 {...props} />
  ) : (
    <TagsFormBodyV2 {...props} />
  );
};
